export default IconRazor => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-razor" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M7 3h10v4h-10z" />
  <path d="M12 7v4" />
  <path d="M12 11a2 2 0 0 1 2 2v6a2 2 0 1 1 -4 0v-6a2 2 0 0 1 2 -2z" />
</svg>`;